import "jquery";
import * as ko from "knockout";
import {BaseCropComponent} from "./BaseCropComponent";
import { StorageCrop } from "../Models/Crops/StorageCrop";
import { CollectedStorageCropInfo } from "../Models/Crops/CollectedStorageCropInfo";
import { YearlyPdf } from "../Models/Crops/YearlyPdf";
import { groupBy, map, orderBy, forEach, isEmpty, find, filter } from "lodash-es";
import { PdfEntry, PdfEntryWithType } from "../Models/Pdf/PdfEntry"

export class StorageCrops extends BaseCropComponent<StorageCrop> {
    constructor() {
        super($('#storage-crops-table'));
    }
    init(): void {
        this.cropsApi.getCollectedStorageCropInfo().then((res) => {
            // set harvestOverviews

            var groupedList = groupBy(res.StorageHarvestOverviews, (item: YearlyPdf) => item.CropYear);
            forEach(groupedList, e => {
                const year = e[0].CropYear;
                res.StorageCrops.forEach(x => {
                    if (x.CropYear.toString() === year) {
                        res.StorageHarvestOverviews = e; 
                    }
                });
            });

            res.StorageCrops.forEach(x => {
                var all: PdfEntryWithType[] = []; 

                var oo = filter(res.StorageHarvestOverviews,
                    (pdf: YearlyPdf) => pdf.CropYear === x.CropYear.toString());
                if (oo != null) {
                    x.HarvestOverviews = map(oo, xx => xx.PdfEntry);
                    all = all.concat(map(oo, xx => new PdfEntryWithType(xx.PdfEntry, "overview")));
                }

                var yy = filter(res.InformationLetters,
                    (pdf: YearlyPdf) => pdf.CropYear === x.CropYear.toString());
                if (yy != null) {
                    x.InformationLetter = map(yy, xx => xx.PdfEntry);
                   all =  all.concat(map(yy, xx => new PdfEntryWithType(xx.PdfEntry, "info")));
                }

                var tt = filter(res.HarvestInstructions,
                    (pdf: YearlyPdf) => pdf.CropYear === x.CropYear.toString());
                if (tt != null) {
                    x.HarvestInstructions = map(tt, xx => xx.PdfEntry);
                   all =  all.concat(map(tt, xx => new PdfEntryWithType(xx.PdfEntry, "instruction")));
                }

                x.AllYearlyPdfs = all; 


            });


            super.init(res.StorageCrops);
        });
    }
}